function renderPrice(price: string, currency: string) {
  return (
    <div>
      {
        <span>
          {price} {currency}
        </span>
      }
    </div>
  );
}

function sanitizeMeasure(measure: string | null): string {
  if (!measure) return '';
  const convertedMeasure = measure.replace(/[А-Яа-я]/g, '');

  return convertedMeasure;
}

function renderMeasure(measure: string | null): string | JSX.Element {
  if (!measure) return '';
  const convertedMeasure = measure.replace(/[А-Яа-я]/g, '');

  return <span>{convertedMeasure}</span>;
}

export function renderWeight(weight: string | null): string {
  if (!weight) return '';
  const convertedMeasure = weight.replace(/[А-Яа-я]/g, '');

  return convertedMeasure;
}

const columnsFoodType = [
  {
    Header: 'Наименование',
    accessor: 'name',
  },
  {
    Header: 'Время начала ',
    accessor: 'start_time',
  },
  {
    Header: 'Время конца',
    accessor: 'end_time',
  },
  {
    Header: 'Повтор',
    accessor: 'repeat',
    Cell: ({ value }: any) => (
      <>
        {value === 'Everyday' ? <span>Каждый день </span> : null}
        {value === 'Weekday' ? <span>В будние дни</span> : null}
        {value === 'Weekend' ? <span>В выходные</span> : null}
      </>
    ),
  },
];

export { columnsFoodType, renderPrice, renderMeasure, sanitizeMeasure };
